import { ReactNode } from "react";
import { ConditionalRenderContext, useConditionalRenderContext } from "./customHooks";

export function ConditionalRenderContextProvider({ children }: {children: ReactNode}) {
  const conditionalRender = useConditionalRenderContext();

  return (<ConditionalRenderContext.Provider value={conditionalRender}>{children}</ConditionalRenderContext.Provider>);
}